/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { SecurityScanResult } from '../models/SecurityScanResult';

export class SecurityScan {
  /**
  * Eon-assigned snapshot ID.
  */
  'snapshotId': string;
  /**
  * bottom line conclusion of the security scan.
  */
  'conclusion': SecurityScanConclusionEnum;
  /**
  * Number of suspicious evidences backing the conclusion
  */
  'totalEvidenceCount': number;
  /**
  * Date and time the scan was ended.
  */
  'createdTime': Date;
  /**
  * Confidence score from 0.0 to 1.0 indicating likelihood of the conclusion
  */
  'confidenceScore'?: number;
  /**
  * Explanation for this conclusion
  */
  'justification'?: string;
  /**
  * Type of detector that produced this conclusion
  */
  'detectorType'?: SecurityScanDetectorTypeEnum;
  /**
  * Detailed results of the security scan
  */
  'results'?: Array<SecurityScanResult>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "snapshotId",
      "baseName": "snapshotId",
      "type": "string",
      "format": ""
    },
    {
      "name": "conclusion",
      "baseName": "conclusion",
      "type": "SecurityScanConclusionEnum",
      "format": ""
    },
    {
      "name": "totalEvidenceCount",
      "baseName": "totalEvidenceCount",
      "type": "number",
      "format": ""
    },
    {
      "name": "createdTime",
      "baseName": "createdTime",
      "type": "Date",
      "format": "date-time"
    },
    {
      "name": "confidenceScore",
      "baseName": "confidenceScore",
      "type": "number",
      "format": "float"
    },
    {
      "name": "justification",
      "baseName": "justification",
      "type": "string",
      "format": ""
    },
    {
      "name": "detectorType",
      "baseName": "detectorType",
      "type": "SecurityScanDetectorTypeEnum",
      "format": ""
    },
    {
      "name": "results",
      "baseName": "results",
      "type": "Array<SecurityScanResult>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return SecurityScan.attributeTypeMap;
  }

  public constructor() {
  }
}


export enum SecurityScanConclusionEnum {
  Clean = 'CLEAN',
  HighChanceForRansomware = 'HIGH_CHANCE_FOR_RANSOMWARE',
  DataAnomalyDetected = 'DATA_ANOMALY_DETECTED',
  MalwareDetected = 'MALWARE_DETECTED'
}
export enum SecurityScanDetectorTypeEnum {
  Malware = 'MALWARE',
  RansomwareBehavior = 'RANSOMWARE_BEHAVIOR',
  DataAnomaly = 'DATA_ANOMALY'
}

